import { defineStore } from 'pinia';
import { getGroupList } from '../api/user.js'

export default defineStore('groupStore', {
	state: () => {
		return {
			groups: []
		}
	},
	actions: {
		setGroups(groups) {
			this.groups = groups || [];
		},
		addGroup(group) {
			if (this.groups.some(g => g.groupID == group.groupID)) {
				this.updateGroup(group)
			} else {
				this.groups.unshift(group);
			}
		},
		removeGroup(groupID) {
			this.groups.filter(g => g.groupID == groupID).forEach(g => g.quit = true);
		},
		updateGroup(group) {
			this.groups.forEach((g, idx) => {
				if (g.groupID == group.groupID) {
					Object.assign(this.groups[idx], group);
				}
			})
		},
		clear() {
			this.groups = [];
		},
		loadGroup() {
			return new Promise((resolve, reject) => {
				console.log('[groupStore] loadGroup 开始...');
				getGroupList().then(groups => {
					console.log('[groupStore] loadGroup 成功, 群组数量:', Array.isArray(groups) ? groups.length : '非数组');
					// 多号同群时接口按"账号×群"返回多行（每账号一行），群列表按群去重保留首行，
					// 避免同一群重复展示（群会话已是群维度单条，列表应对齐）。
					// 保留行携带 vid/accountID/login（群列表展示与会话元数据依赖），去重前按登录优先
					// 稳定排序：后端已按 login 优先排序，此处双保险防顺序漂移导致保留到离线账号行
					const list = Array.isArray(groups) ? groups : [];
					const sorted = list.slice().sort((a, b) => ((b && b.login) ? 1 : 0) - ((a && a.login) ? 1 : 0));
					const seen = new Set();
					const deduped = sorted.filter(g => {
						if (!g || seen.has(g.groupID)) return false;
						seen.add(g.groupID);
						return true;
					});
					this.setGroups(deduped);
					resolve();
				}).catch(e => {
					console.error('[groupStore] loadGroup 失败:', e);
					reject(e);
				})
			});
		}
	},
	getters: {
		findGroup: (state) => (groupID) => {
			return state.groups.find(g => g.groupID == groupID);
		},
		isGroup: (state) => (groupID) => {
			return state.groups.filter(g => !g.quit).some(g => g.groupID == groupID);
		},
	}
});
